module.exports = "pegasus/assets/blocks/header-6-theme4.png";